//Polyfills
import 'whatwg-fetch';
// import 'core-js/features/object/values';
// import 'core-js/features/object/iterate-values';
// import 'core-js/stable';
// import 'regenerator-runtime/runtime';
// import 'core-js/features/symbol';
import 'core-js/features/map';
import 'core-js/features/set';
// import 'core-js/features/promise';
import 'core-js/features/array/fill';
import 'core-js/features/array/find';
// import 'core-js/features/array/includes';
import 'core-js/features/array/from';
import 'core-js/features/array/find-index';
// import 'core-js/features/object/assign';
// import 'core-js/features/number/is-nan';


// Dependencies
import React from 'react';  
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { AppContainer } from 'react-hot-loader';

// Components
import App from './components/app';

// Redux
import { configureStore } from './store/store';
import { initialState } from './store/initialState';

// CSS
import 'resources/css/suscripcionesPortal.css';
import 'react-confirm-alert/src/react-confirm-alert.css';

// JS
import 'regenerator-runtime/runtime.js';


document.addEventListener("DOMContentLoaded", function(){
    const store = configureStore(initialState);

    // var suscribete = document.createElement('div')
    // suscribete.setAttribute('id','subscribeButton')
    // var social = document.getElementById("social-links")
    // if(social != null)
    // social.appendChild(suscribete)

    const render = Component => {
        ReactDOM.render(
            <AppContainer>
                <Provider store={store}>
                    <Component />
                </Provider>
            </AppContainer>,
            document.getElementById('subscribeButton')
        );
    };

    render(App);

    if (module.hot) {
        module.hot.accept('./reducers/appReducer.js', ()  => {
            const nextReducer = require('./reducers/appReducer.js').default;
            store.replaceReducer(nextReducer);
        })
    }

});


// function Init(){
//     const store = configureStore(initialState);

//     var suscribete = document.createElement('div')
//         suscribete.setAttribute('id','subscribeButton')
//         var social = document.getElementById("social-links")
//         if(social != null)
//         social.appendChild(suscribete)
    
//     const render = Component => {
//         ReactDOM.render(
//             <AppContainer>
//                 <Provider store={store}>
//                     <Component />
//                 </Provider>
//             </AppContainer>
//         );
//     };
    
//     render(App);
// }

// function ready(callback) {
//     if (document.readyState != 'loading' && document.readyState != 'interactive') callback();
//     else if (document.addEventListener) document.addEventListener('DOMContentLoaded', callback);
//     else document.attachEvent('onreadystatechange', function () {
//         if (document.readyState == 'complete') callback();
//     });
// }



// ready(Init);